// extracted by mini-css-extract-plugin
export default {"root":"style_root__3ajw8","suffix":"style_suffix__XH62i"};